import { render, staticRenderFns } from "./customerAgingAnalysis.vue?vue&type=template&id=1be05a9b"
import script from "./customerAgingAnalysis.vue?vue&type=script&lang=js"
export * from "./customerAgingAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports